// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YPQdA","right":"styles_right__2A6A-"};